import {defaultCallback, defaultErrCallback, defaultJsonCallback} from "./main_callbacks";
import {showLoading} from "./main";
import {createServerInfo, getUrl, isDesktop, openWithParams} from "./main_ptx";
import {initTables} from "./main_tables";
import {initRemoteTabLoad, initTab} from "./main_tabs";
import {reloadCurrent} from "./main_page";
import {submitCurrent} from "./main_form";


/** show modal form from url, create elements if necessary
 * @alias Ptx.modal.show
 * @param modalId - modal window id
 * @param url - what to be loaded
 * @param opts - form options (optional), ptxSize for dialog size, params for url params
 */


export function show(modalId, url, opts) {
	const modalElement = $('#' + modalId);
	if (modalElement.length > 0) {
		// Extra modal behavior, as in the original code
		Ptx.modal.lowerModal = Ptx.modal.ctx;
		modalId = "extraModal";
	}
	const defaultOpts = {
		ptxSize: '',
		cssClass: '',
		params: { sm_dec: 'none' },
		method: 'GET',
		loader: '#loader',
		keyboard: false,
	};

	opts = { ...defaultOpts, ...opts };

	const { ptxSize, cssClass, params, method, loader } = opts;

	const csrfToken = $("meta[name='_csrf']").attr("content");
	const csrfHeader = $("meta[name='_csrf_header']").attr("content");

	//modalElement.closest('.modal-backdrop').remove();

	const animationClass = Ptx.modal.disableAnimation ? 'fade-none' : '';
	const modalStr = `<div class="modal fade ${animationClass} ${cssClass}" data-bs-focus="false" id="${modalId}" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog ${animationClass} ${ptxSize}">
    </div>
  </div>`;

	const modalContent = $(modalStr);
	$('body').append(modalContent);

	const modal = new bootstrap.Modal($('#' + modalId), {
		backdrop: 'static',
		keyboard: false
	});

	Ptx.modal.ajax = $.ajax({
		type: method,
		url: url,
		data: params,
		beforeSend: (xhr) => {
			xhr.setRequestHeader(csrfHeader, csrfToken);
			showLoading(true, 'modal', null);
		},
	}).done((data, status, xhr) => {
		const out = data;
		const serverInfo = createServerInfo(status, xhr, url, false, params);

		if (serverInfo.isJson) {
			defaultJsonCallback(data, serverInfo);
		} else {
			Ptx.modal.ctx = {
				tab: {},
				modal_id: modalId,
				url: url,
				opts: opts,
				openByHash: opts.openByHash || false, // optional param to close modal with url
				lastTab: 0,
				hasChanged: false,
				ignoreChanges: false, // ignore form changes (useful for form changes caused by JS)
			};

			const md = $(modalContent).modal(opts).find('.modal-dialog').html(out);
			Ptx.modal.ctx.window = md.closest('.modal');

			modal.show();
			// when modal window is visible for the user
			$(modalContent).on('shown.bs.modal', handleShow);
			$(modalContent).on('hidden.bs.modal', handleClose);
		}
		showLoading(false, 'modal', null);
	}).fail((xhr, textStatus, error) => {
		defaultErrCallback(xhr, textStatus, error, url, loader);
	});
}

/**
 * init modal window after show
 * @alias Ptx.modal.initModal
 * @param ctx - ctx of modal window
 */
export function initialize(ctx) {
	initTab(ctx);
	initRemoteTabLoad('a.ptx-ajax-tab', ctx); //* M - show url in new remote loaded tab

	if (Ptx.modal.ctx.formInit) Ptx.modal.ctx.formInit(ctx);
	if (Ptx.modal.ctx.onload) Ptx.modal.ctx.onload(ctx);

	$('a.ptx-modal-open-in-current', ctx).on('click', function (e) {
		e.preventDefault();
		var urlPath = $(this).attr('href');
		openModalWithUrl(urlPath);
	});

	initMultiselect(ctx);
	initTables(ctx);
	Ptx.fn.initTooltips(ctx);

	const $modalBody = $(".modal-body", ctx);
	$modalBody.attr('tabindex', -1).focus();

	const draggableAttribute = $modalBody.data('ptx-modal-draggable');
	draggable(draggableAttribute, ctx);
	Ptx.modal.ctx.ignoreChanges = $modalBody.attr("data-ignore-changes") === "true";

	// It is possible when the validation of any form fails, then "data-handle-close-url"
	// comes here as undefined, so that is the reason for this treatment.
	var dataHandleCloseUrl = $modalBody.data('handle-close-url');
	if (dataHandleCloseUrl) {
		Ptx.modal.ctx.handleCloseUrl = $modalBody.data('handle-close-url');
	}

	$('.nav-tabs li.active a', ctx).trigger('click');

	if (Ptx.modal.disableAnimation === true) {
		$('[id^=modal-]').removeClass('fade-none');
		$('.modal-dialog').removeClass('fade-none');
		Ptx.modal.disableAnimation = false;
		Ptx.modal.refreshOnClose = false;
	}
}

function openModalWithUrl(url) {
	openWithParams(getUrl(url), "GET", { sm_dec: 'none' }, function (data) {
		$(Ptx.modal.ctx.window).find('.modal-content').html(data);
		initialize(Ptx.modal.ctx.window);
	});
}

export function initMultiselect(ctx) {
	function createSearchInput(placeholderKey) {
		return `<input type='text' class='search-input form-control' autocomplete='off' placeholder='${Ptx.getMsg(placeholderKey)}'>`;
	}

	function initQuickSearch($element, that, searchSelector) {
		return $element.quicksearch(searchSelector).on('keydown', function (e) {
			if (e.which === 40) {
				that.$selectableUl.focus();
				return false;
			}
		});
	}

	$('.multi-select', ctx).multiSelect({
		selectableHeader: createSearchInput('common.btn.search'),
		selectionHeader: createSearchInput('common.btn.search'),
		afterInit: function (ms) {
			const that = this;
			const $selectableSearch = that.$selectableUl.prev();
			const $selectionSearch = that.$selectionUl.prev();

			that.qs1 = initQuickSearch($selectableSearch, that, '.ms-elem-selectable:not(.ms-selected)');
			that.qs2 = initQuickSearch($selectionSearch, that, '.ms-elem-selection.ms-selected');
		},
		afterSelect: function () {
			this.qs1.cache();
			this.qs2.cache();
		},
		afterDeselect: function () {
			this.qs1.cache();
			this.qs2.cache();
		},
	});

	$('.ptx-multi-select-all, .ptx-multi-select-none', ctx).click(function () {
		const id = $(this).attr('data-id').replace(/\./g, '\\.');
		const listClass = $(this).hasClass('ptx-multi-select-all') ? '.ms-selectable' : '.ms-selection';
		const action = $(this).hasClass('ptx-multi-select-all') ? 'select' : 'deselect';

		const el = [];

		$(`#ms-${id} ${listClass} .ms-list li:visible`).each(function () {
			const text = $(this).text();
			$(`#${id} option`).each(function () {
				if (text === $(this).text()) {
					el.push($(this).val());
				}
			});
		});

		$(`#${id}`).multiSelect(action, el);
	});
}

/**
 * EVENT HANDLER FUNCTION
 * @alias Ptx.modal.handleShow
 * Modal open event function handler
 */
export function handleShow() {
	let ctx = Ptx.modal.ctx.window;
	$('#page-filter, #page-content').addClass("not-print");

	const reseller = $('#resellerId option:selected').text();
	const client = $('#clientId option:selected').text();

	if (reseller && $('.modal-header .modal-header-title', ctx).length < 1) {
		$('.modal-dialog .modal-header .close', ctx).after(
				`<strong class="font-smallest-i modal-header-title">${reseller} <i class="fa-solid fa-long-arrow-right"></i> ${client}</strong>`
		);
	}

	initialize(ctx);

	// Add hash to modal with URL if it doesn't exist
	location.hash = location.hash.includes("modal") ? location.hash : location.hash + '?modal';
}

/**
 * EVENT HANDLER FUNCTION
 * @alias Ptx.modal.handleClose
 * Modal close event function handler
 */
export function handleClose() {
	const $pageFilter = $('#page-filter');
	const $pageContent = $('#page-content');
	const $extraModal = $('#extraModal');
	const $body = $('body');

	// Handle unloading
	if (Ptx.modal.ctx.tab && Ptx.modal.ctx.tab.onunload) {
		Ptx.modal.ctx.tab.onunload();
	}
	if (Ptx.modal.ctx.onunload) {
		Ptx.modal.ctx.onunload(Ptx.modal.ctx.window);
	}

	// Handle session modal
	function handleSessionModal() {
		if (Ptx.modal.ctx.handleCloseUrl) {
			Ptx.fn.openPtx(Ptx.modal.ctx.handleCloseUrl, "POST");
		}
	}

	// Close lower modal
	function closeLowerModal() {
		if (Ptx.modal.refreshOnClose === true) {
			handleSessionModal();
		}
		$('[id^=modal-]').remove();
		$('.modal-backdrop').remove();
		$body.css('overflow', '');
		Ptx.modal.ctx = null;

		if (history.pushState) {
			history.pushState("", document.title, location.pathname + location.search);
		} else {
			const scrollV = document.body.scrollTop;
			const scrollH = document.body.scrollLeft;
			location.hash = "";
			document.body.scrollTop = scrollV;
			document.body.scrollLeft = scrollH;
		}
	}

	// Combine class removal
	$pageFilter.add($pageContent).toggleClass("not-print", false);

	if ($extraModal.length > 0) {
		Ptx.modal.ctx = Ptx.modal.lowerModal;
		$extraModal.remove();
		$body.addClass('modal-open');

		if (Ptx.modal.refreshOnClose === true) {
			closeLowerModal();
			Ptx.modal.disableAnimation = true;
			show(Ptx.modal.lowerModal.modal_id, Ptx.modal.lowerModal.url, Ptx.modal.lowerModal.opts);
		}
		Ptx.fn.reloadContentAll(Ptx.modal.ctx.window);
	} else {
		handleSessionModal();
		closeLowerModal();
	}
}

/**
 * Modal dragging functionality for desktops.
 * Double click will return the modal to default position.
 * @alias Ptx.modal.draggable
 * @param draggableAttribute boolean (if false, modal will not be draggable)
 * @param ctx current modal context
 */
export function draggable(draggableAttribute, ctx) {
	if (isDesktop() && draggableAttribute !== false) {
		const modalTitleTag = $('.modal-header', ctx);
		let isDragging = false;
		let startX, startY, modal;

		modalTitleTag.addClass('cursor-move');

		modalTitleTag.on('mousedown', (e) => {
			if (!$(e.target).hasClass('close')) {
				isDragging = true;
				modal = $(e.target).closest(".modal-dialog", ctx);
				startX = e.pageX - parseInt(modal.css('left'));
				startY = e.pageY - parseInt(modal.css('top'));
				e.preventDefault();
			}
		});

		$(document)
				.on('mousemove', (e) => {
					if (isDragging) {
						modal.css({
							left: e.pageX - startX,
							top: e.pageY - startY,
						});
						e.preventDefault();
					}
				})
				.on('mouseup', () => {
					isDragging = false;
				});

		modalTitleTag.on("dblclick", () => {
			modal.css({ left: 0, top: 0 });
		});
	}
}

/**
 * hide currently shown modal window
 * @alias Ptx.modal.hideCurrent
 */
export function hideCurrent() {
	if(Ptx.modal.ctx){
		Ptx.modal.ctx.window.modal('hide');
	}
}

/**
 *  init common form submit via ajax in modal window
 *  @alias Ptx.modal.form.init
 *  @param ctx - jQ context where to search
 */
export function initForm(ctx) {

	const formElements = $('form :input, form textarea, form input[type="checkbox"]', ctx);

	function setFormChanged() {
		if (Ptx.modal.ctx?.ignoreChanges === false) {
			Ptx.modal.ctx.hasChanged = true;
			// Unbind events when form has changes, so we don't spam this function.
			formElements.off('input change', setFormChanged);
		}
	}

	if (Ptx.modal.ctx?.hasChanged === false) {
		formElements.on('input change', setFormChanged);
	}

	$(ctx).on('focusin', function(e) {
		if ($(e.target).closest(".mce-window").length) {
			e.stopImmediatePropagation();
		}
	});

	//* M - submit current form and close modal if ok
	$('.ptx-modal-form-submit:not(:disabled)', ctx).on('click', function (e) {
		e.preventDefault();
		if (tinymce.editors.length) {
			tinymce.triggerSave();
		}

		if ($('.ptx-modal-form-submit:not(:disabled)', ctx).hasClass('refresh-on-modal-close')) {
			Ptx.modal.refreshOnClose = true;
		}
		submitForm($(this));
	});

	//* M - submit current form by change and close modal if ok
	$('.ptx-form-auto-submit', ctx).on('change', function (e) {
		e.preventDefault();
		submitForm($(this));
	});
	function handleModalCloseWithoutSubmit(element, name) {
		var isTab = $(element).hasClass('ptx-close-current-tab');
		if (Ptx.modal.ctx.hasChanged && name !== '_back') {
			Ptx.confirm(Ptx.getMsg('confirmCloseTab'), function (msg) {
				if (msg) {
					if (name === '_backBtn' && !isTab) {
						hideCurrent();
					} else {
						submitForm($('.ptx-modal-form-cancel', ctx));
					}
				}
			});
		} else if (name === '_backBtn' && !isTab) {
			hideCurrent();
		} else {
			submitForm($(element));
		}
	}

// Add an event listener to the modal to handle ESC key press
	$(ctx).on('keydown', function (e) {
		if (e.key === "Escape") {
			handleModalCloseWithoutSubmit(this, '_backBtn');
		}
	});

// Add an event listener to the document to handle clicks outside the modal
	$(ctx).on('mousedown', function (e) {
		var $target = $(e.target);
		var $modal = $('.modal'); // Adjust this selector to match the modal backdrop class.

		// Check if the click is outside the modal
		if ($target.is($modal)) {
			e.preventDefault();
			handleModalCloseWithoutSubmit(this, '_backBtn');
		}
	});

// Add an event listener to handle clicks on .ptx-modal-form-cancel
	$('.ptx-modal-form-cancel', ctx).on('click', function (e) {
		e.preventDefault();
		var name = $(this).attr('name');
		handleModalCloseWithoutSubmit(this, name);
	});

	//* M - close modal without submission, and reload page
	$('.ptx-modal-form-cancel-reload', ctx).on('click', function (e) {
		if (!$('#extraModal').length > 0) {
			e.preventDefault();
			hideCurrent();
			reloadCurrent();
		}
	});

	//* M - reload page under modal window
	$('.ptx-modal-page-refresh', ctx).on('click', function (e) {
		if (!$('#extraModal').length > 0) {
			reloadCurrent();
		}
	});
}

/**
 * submit current modal form with default options - current is that where this ele is
 * Check Ptx.form.submitCurrent for overriding this behaviour
 * @alias Ptx.modal.form.submitCurrent
 * @param ele element within form
 */
export function submitForm(ele) {
	const f = ele.closest('form');
	const modalContent = ele.closest('.modal-dialog');

	f.append('<input type="hidden" name="sm_dec" value="none" />');
	f.find('.ptx-modal-form-submit').prop('disabled', true);

	submitCurrent(ele, modalContent, defaultCallback);
}